<template>
  <div class="BlockList" v-show="bfloag">
    <div class="BlockList-W">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close"
      />
      <div class="blockbox">
        <div class="blockhead">
          <div>USDT Lock Transaction Hash</div>
          <div>DO Lock Transaction Hash</div>
          <div>Amount of PRL-X received</div>
          <div>Status</div>
        </div>
        <div class="blockcont">
          <div class="blockli" v-for="(item, index) in list" :key="index">
            <div class="blockhash">
              <div>{{ item.coinTxHash }}</div>
              <img
                src="../../../assets/pc/Login/copy.png"
                v-clipboard:copy="item.coinTxHash1"
                v-clipboard:success="copyClicked"
                v-clipboard:error="onError"
              />
            </div>
            <div>{{ item.txHash }}</div>
            <div>{{ item.awardAmount }}</div>
            <div :class="item.status == 'success' ? 'status' : 'status1'">
              {{ item.status }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/assets/server/api";
import { getSubStr, goPAGE } from "@/utils/utils";
export default {
  props: ["bflog", "rflog", "relist", "total"],
  data() {
    return {
      radioDisabled: false,
      formReadOnly: false,
      bfloag: false,
      list: [],
      total1: null,
      form: {
        email: "",
        do: "",
        code: "",
        resource: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    deep: true,
    bflog(val) {
      this.bfloag = val;
    },
    rflog(val) {
      this.bfloag = val;
    },
    relist(val) {
      this.list = val;
     // console.log(this.list);
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].coinTxHash1 = this.list[i].coinTxHash;
        this.list[i].coinTxHash = getSubStr(this.list[i].coinTxHash, 0, 5);
        this.list[i].txHash = getSubStr(this.list[i].txHash, 0, 5);
      }
    },
    total(val) {
      this.total1 = val;
    },
  },
  methods: {
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    close() {
      this.bfloag = false;
      this.$emit("bloflog", this.bfloag);
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 1013px;
    min-height: 249px;
    background: #151515;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    position: absolute;
    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .imgs {
      width: 18px;
      height: 18px;
      margin-left: 983px;
      margin-top: 12px;
      cursor: pointer;
    }
    .blockbox {
      margin-top: 10px;
      width: 983px;
      margin: 0 auto;
      .blockhead {
        display: flex;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.6);
        div:nth-child(1) {
          width: 30%;
          text-align: left;
          padding-left: 10px;
        }
        div:nth-child(2) {
          width: 30%;
          text-align: left;
        }
        div:nth-child(3) {
          width: 30%;
          text-align: left;
        }
        div:nth-child(4) {
          width: 10%;
        }
      }
      .blockcont {
        padding-top: 16px;
        .blockli {
          display: flex;
          height: 36px;
          line-height: 36px;
          border-bottom: 1px solid #5b5b5b;
          padding-bottom: 4px;
          .blockhash {
            width: 30%;
            display: flex;

            div {
              width: 130px;
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
            }
            img {
              width: 21px;
              height: 21px;
              margin-top: 8px;
              cursor: pointer;
            }
          }
          div:nth-child(1) {
            padding-left: 6px;
          }
          div:nth-child(2) {
            width: 30%;
            text-align: left;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
          }
          div:nth-child(3) {
            width: 30%;
            text-align: left;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
          }
          div:nth-child(4) {
            width: 10%;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 16px;
            // color: #f6cb3c;
          }
          .status {
          
            color: #3cf6f0;
          }
          .status1{
            color: #f6cb3c;
          }
        }
        .blockli:last-child{
          border-bottom: none;
        }
      }
    }
  }
}
</style>
